import React from 'react';

const AlertIcon = () => {
  return (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.72479 18C1.54146 18 1.37479 17.9542 1.22479 17.8625C1.07479 17.7708 0.958123 17.65 0.87479 17.5C0.791456 17.35 0.745623 17.1875 0.73729 17.0125C0.728956 16.8375 0.77479 16.6667 0.87479 16.5L10.1248 0.5C10.2248 0.333333 10.354 0.208333 10.5123 0.125C10.6706 0.0416667 10.8331 0 10.9998 0C11.1665 0 11.329 0.0416667 11.4873 0.125C11.6456 0.208333 11.7748 0.333333 11.8748 0.5L21.1248 16.5C21.2248 16.6667 21.2706 16.8375 21.2623 17.0125C21.254 17.2833 21.2081 17.35 21.1248 17.5C21.0415 17.65 20.9248 17.7708 20.7748 17.8625C20.6248 17.9542 20.4581 18 20.2748 18H1.72479ZM10.9998 15C11.2831 15 11.5206 14.9042 11.7123 14.7125C11.904 14.5208 11.9998 14.2833 11.9998 14C11.9998 13.7167 11.904 13.4792 11.7123 13.2875C11.5206 13.0958 11.2831 13 10.9998 13C10.7165 13 10.479 13.0958 10.2873 13.2875C10.0956 13.4792 9.99979 13.7167 9.99979 14C9.99979 14.2833 10.0956 14.5208 10.2873 14.7125C10.479 14.9042 10.7165 15 10.9998 15ZM10.9998 12C11.2831 12 11.5206 11.9042 11.7123 11.7125C11.904 11.5208 11.9998 11.2833 11.9998 11V8C11.9998 7.71667 11.904 7.47917 11.7123 7.2875C11.5206 7.09583 11.2831 7 10.9998 7C10.7165 7 10.479 7.09583 10.2873 7.2875C10.0956 7.47917 9.99979 7.71667 9.99979 8V11C9.99979 11.2833 10.0956 11.5208 10.2873 11.7125C10.479 11.9042 10.7165 12 10.9998 12Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default AlertIcon;
